import React from 'react'
import { Box } from '@mui/material'
import { GOLD, formatTicket } from '../../utils/luckyDraw'

const WIDTH_PX = 240

/**
 * One ticket read off the wall on hover, for the operator rather than the room. Sits above the
 * card unless there is no room above it.
 */
const TicketPeek = ({ rect, ticket, companyName, prizeName }) => {
  const isAbove = rect.top > 152
  // Centred on the card, then pulled back inside the screen at both edges.
  const left = Math.min(
    Math.max(rect.left + rect.width / 2 - WIDTH_PX / 2, 12),
    window.innerWidth - WIDTH_PX - 12,
  )

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 5,
        left,
        ...(isAbove ? { bottom: window.innerHeight - rect.top + 16 } : { top: rect.bottom + 16 }),
        width: WIDTH_PX,
        px: 1.5,
        py: 1.25,
        borderRadius: '8px',
        border: '1px solid rgba(255, 255, 255, 0.18)',
        backgroundColor: 'rgba(12, 12, 18, 0.96)',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.6)',
        // Never under the cursor: the card's own hover would drop the moment the panel covered it.
        pointerEvents: 'none',
      }}
    >
      <Box sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem', letterSpacing: '0.18em' }}>
        #{formatTicket(ticket)}
      </Box>
      <Box
        sx={{
          color: '#fff',
          fontWeight: 700,
          fontSize: '0.95rem',
          lineHeight: 1.25,
          textTransform: 'uppercase',
          overflowWrap: 'anywhere',
          mt: 0.25,
        }}
      >
        {companyName}
      </Box>
      {prizeName && (
        <Box
          sx={{
            mt: 0.75,
            pt: 0.75,
            borderTop: '1px solid rgba(255,255,255,0.12)',
            color: GOLD,
            fontWeight: 700,
            fontSize: '0.8rem',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            overflowWrap: 'anywhere',
          }}
        >
          {prizeName}
        </Box>
      )}
    </Box>
  )
}

export default TicketPeek
